import React from "react";
import Layout from "../../components/Layout";
import Libelle from "../../_i18n/fr.json";
import ProtectionDonnees from "./ProtectionDonnees";

function ProtectionDonneesPage() {
  return (
    <React.Fragment>
      <Layout title={Libelle.pageProtection.titre}>
        <ProtectionDonnees />
      </Layout>
    </React.Fragment>
  );
}

export default ProtectionDonneesPage;
